 import { styled } from "@mui/material/styles";

 const StyledProductsTable = styled("div")(
   ({ theme }) => `
.custom-switch {
  width: 40px;
  height: 15px;
  background-color: ${theme.palette.customColor.secondarySecond};
  border-radius: 30px !important;
  cursor: pointer;
  position: relative;
  transition: 0.3s ease;
}

.active1 {
  background-color: ${theme.palette.customColor.green} !important;
}

.custom-switch .MuiSwitch-track {
  background-color: transparent !important;
}

.custom-switch .MuiSwitch-thumb {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 16px;
  height: 16px;
  background-color: ${theme.palette.customColor.white} !important;
  border-radius: 50%;
  transition: transform 0.3s ease;
}

 .Mui-checked .MuiSwitch-thumb {
  transform: translateX(-3px) !important;
}

.custom-switch-text {
  font-family: Lexend;
  font-weight: 400;
  font-size: 12px;
  margin-left: 10px;
  line-height: 15px;
  color: ${theme.palette.primary.main};
}
`
 );

 export default StyledProductsTable;

